export const TrialPackageRoutes: Readonly<{
  PageIndex: 'trial-package';
}> = {
  PageIndex: 'trial-package',
};
